import React from "react"

import Layout from "../components/layout"
import GlobalStyle from "../components/globalStyle"
import SEO from "../components/seo"
import Hero from "../components/hero"
import Section from "../components/section"
import Benefits from "../components/benefits"
import Easy from "../components/easy"
import Hi from "../components/sayhi"
import Footer from "../components/footer"

const IndexPage = () => (
  <Layout>
    <GlobalStyle />
    <SEO title="" />
    <Hero />
    <Hi header="Learn More" />
    <Section
      redline="Expanding"
      header="your team is no easy task."
      text="Hiring offshore is a great way to scale, but it's not without it's risks.
      Let our expert team guide you with expert advice and a clear strategy for succesful growth abroad."
    />
    <Benefits />
    <Section
      redline="Think"
      header="of us as your offshore consultant"
      text="We know how to grow teams, and we understand the factors of outsourcing, freelancing, and offshoring in Manila. Our service works to ensure that you make the best choices in regard to growing your team as well as recognise how to expand further."
    />
    <Easy />
    <Hi header="Let's chat" />
    <Footer></Footer>
  </Layout>
)

export default IndexPage
